import { Injectable, Injector } from '@angular/core';

import { BaseComponents } from '../../base.component';

import { PixelService } from 'ngx-pixel-eventid'

@Injectable({
  providedIn: 'root'
})

export class FacebookPixelService extends BaseComponents {

  constructor( 
    protected injectorObj: Injector,
    private pixelService: PixelService 
  ) {
    super(injectorObj); 
  }

  setTagFacebookPixel() {
    this.pixelService.initialize()
  }
}